(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-brand-enablers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-brand-enablers-v16')) {
    customElements.define('about-brand-enablers-v16', class extends HTMLElement {
      connectedCallback() {
        this.labels = Array.from(this.querySelectorAll('[data-enabler-label]'));
        this.media = Array.from(this.querySelectorAll('[data-enabler-media]'));
        this.mediaContainer = this.querySelector('.about-brand-enablers__media');
        this.stage = this.querySelector('.about-brand-enablers__stage');
        this.visuals = this.media.map((item) => item.querySelector('picture, .about-brand-enablers__placeholder'));
        this.dots = Array.from(this.querySelectorAll('[data-enabler-dot]'));
        this.captions = Array.from(this.querySelectorAll('[data-enabler-caption]'));
        this.activeIndex = -1;
        this.mobileIndex = 0;
        this.raf = 0;
        this.autoplayTimer = 0;
        this.mobileSettleTimer = 0;
        this.mobileLoopPositioned = false;
        this.mobileJumping = false;
        this.mobileAutoplay = this.dataset.mobileAutoplay === 'true';
        this.mobileAutoplayDelay = Math.max(2, Number(this.dataset.mobileAutoplaySeconds) || 5) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.requestRender = this.requestRender.bind(this);
        this.requestMobileRender = this.requestMobileRender.bind(this);
        this.stopMobileAutoplay = this.stopMobileAutoplay.bind(this);
        this.startMobileAutoplay = this.startMobileAutoplay.bind(this);
        this.setupMobileLoop();
        window.addEventListener('scroll', this.requestRender, { passive: true });
        window.addEventListener('resize', this.requestRender);
        this.mediaContainer.addEventListener('scroll', this.requestMobileRender, { passive: true });
        this.mediaContainer.addEventListener('pointerdown', this.stopMobileAutoplay, { passive: true });
        this.mediaContainer.addEventListener('pointerup', this.startMobileAutoplay, { passive: true });
        this.mediaContainer.addEventListener('pointercancel', this.startMobileAutoplay, { passive: true });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.stopMobileAutoplay();
            this.goToMobileSlide(Number(dot.dataset.enablerDot));
            this.startMobileAutoplay();
          });
        });
        this.mediaContainer.querySelectorAll('img').forEach((image) => {
          if (image.complete) return;
          image.addEventListener('load', () => this.updateMobileHeight(this.mobileIndex), { once: true });
        });
        this.render();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.requestRender);
        window.removeEventListener('resize', this.requestRender);
        this.mediaContainer.removeEventListener('scroll', this.requestMobileRender);
        this.mediaContainer.removeEventListener('pointerdown', this.stopMobileAutoplay);
        this.mediaContainer.removeEventListener('pointerup', this.startMobileAutoplay);
        this.mediaContainer.removeEventListener('pointercancel', this.startMobileAutoplay);
        this.stopMobileAutoplay();
        window.clearTimeout(this.mobileSettleTimer);
        cancelAnimationFrame(this.raf);
      }

      requestRender() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.render();
        });
      }

      requestMobileRender() {
        if (!window.matchMedia('(max-width: 1023px)').matches || this.raf || this.mobileJumping) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const trackIndex = this.getClosestMobileTrackIndex();
          this.setMobileIndex(this.trackIndexToLogicalIndex(trackIndex));
          window.clearTimeout(this.mobileSettleTimer);
          this.mobileSettleTimer = window.setTimeout(() => this.normalizeMobileLoop(), 120);
        });
      }

      setupMobileLoop() {
        if (this.media.length < 2) {
          this.mobileSlides = this.media.slice();
          return;
        }
        const lastClone = this.createMobileClone(this.media[this.media.length - 1], 'before');
        const firstClone = this.createMobileClone(this.media[0], 'after');
        this.mediaContainer.prepend(lastClone);
        this.mediaContainer.append(firstClone);
        this.mobileSlides = Array.from(this.mediaContainer.querySelectorAll('.about-brand-enablers__media-item'));
      }

      createMobileClone(source, position) {
        const clone = source.cloneNode(true);
        clone.removeAttribute('data-enabler-media');
        clone.setAttribute('data-enabler-clone', position);
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('*')].forEach((element) => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });
        return clone;
      }

      ensureMobileLoopPosition() {
        if (this.mobileLoopPositioned || !window.matchMedia('(max-width: 1023px)').matches) return;
        this.mobileLoopPositioned = true;
        requestAnimationFrame(() => {
          this.goToMobileTrackSlide(this.media.length > 1 ? 1 : 0, true);
          this.setMobileIndex(0);
        });
      }

      getClosestMobileTrackIndex() {
        const slides = this.mobileSlides || this.media;
        const center = this.mediaContainer.scrollLeft + (this.mediaContainer.clientWidth / 2);
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
          const distance = Math.abs(slideCenter - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      }

      trackIndexToLogicalIndex(trackIndex) {
        if (this.media.length < 2) return 0;
        if (trackIndex === 0) return this.media.length - 1;
        if (trackIndex === this.media.length + 1) return 0;
        return Math.min(this.media.length - 1, Math.max(0, trackIndex - 1));
      }

      goToMobileTrackSlide(trackIndex, instant = false) {
        const slides = this.mobileSlides || this.media;
        const slide = slides[trackIndex];
        if (!slide) return;
        const targetOffset = slide.offsetLeft - ((this.mediaContainer.clientWidth - slide.offsetWidth) / 2);
        if (instant) {
          this.jumpToMobileOffset(targetOffset);
          return;
        }
        this.mediaContainer.scrollTo({ left: targetOffset, behavior: 'smooth' });
      }

      jumpToMobileOffset(targetOffset) {
        this.mobileJumping = true;
        window.clearTimeout(this.mobileSettleTimer);
        this.mediaContainer.style.scrollBehavior = 'auto';
        this.mediaContainer.style.scrollSnapType = 'none';
        this.mediaContainer.scrollLeft = targetOffset;
        this.mediaContainer.getBoundingClientRect();
        requestAnimationFrame(() => {
          this.mediaContainer.style.removeProperty('scroll-behavior');
          this.mediaContainer.style.removeProperty('scroll-snap-type');
          this.mobileJumping = false;
        });
      }

      goToMobileSlide(index, instant = false, useForwardClone = false) {
        const safeIndex = Math.min(this.media.length - 1, Math.max(0, index));
        let trackIndex = this.media.length > 1 ? safeIndex + 1 : safeIndex;
        if (useForwardClone && this.mobileIndex === this.media.length - 1 && safeIndex === 0) {
          trackIndex = this.media.length + 1;
        }
        this.goToMobileTrackSlide(trackIndex, instant);
        this.setMobileIndex(safeIndex);
      }

      normalizeMobileLoop() {
        if (!window.matchMedia('(max-width: 1023px)').matches || this.media.length < 2) return;
        const trackIndex = this.getClosestMobileTrackIndex();
        if (trackIndex === 0) {
          this.goToMobileTrackSlide(this.media.length, true);
        } else if (trackIndex === this.media.length + 1) {
          this.goToMobileTrackSlide(1, true);
        }
      }

      stopMobileAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = 0;
      }

      startMobileAutoplay() {
        if (this.autoplayTimer || !this.mobileAutoplay || this.reducedMotion || this.media.length < 2) return;
        if (!window.matchMedia('(max-width: 1023px)').matches) return;
        this.autoplayTimer = window.setTimeout(() => {
          this.autoplayTimer = 0;
          if (document.hidden) {
            this.startMobileAutoplay();
            return;
          }
          const nextIndex = (this.mobileIndex + 1) % this.media.length;
          this.goToMobileSlide(nextIndex, false, true);
          this.startMobileAutoplay();
        }, this.mobileAutoplayDelay);
      }

      setMobileIndex(index) {
        const safeIndex = Math.min(this.media.length - 1, Math.max(0, index));
        this.mobileIndex = safeIndex;
        this.dots.forEach((dot, itemIndex) => {
          const active = itemIndex === safeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        this.captions.forEach((caption, itemIndex) => {
          const active = itemIndex === safeIndex;
          caption.classList.toggle('is-active', active);
          caption.setAttribute('aria-hidden', String(!active));
        });
        this.media.forEach((slide, itemIndex) => {
          slide.setAttribute('aria-hidden', String(itemIndex !== safeIndex));
        });
        this.updateMobileHeight(safeIndex);
      }

      updateMobileHeight(index) {
        if (!window.matchMedia('(max-width: 1023px)').matches) {
          this.mediaContainer.style.removeProperty('height');
          return;
        }
        const slide = this.media[index];
        if (!slide) return;
        const height = slide.getBoundingClientRect().height;
        if (height > 0) this.mediaContainer.style.height = `${height}px`;
      }

      render() {
        if (this.reducedMotion || !this.labels.length) return;
        if (window.matchMedia('(max-width: 1023px)').matches) {
          this.ensureMobileLoopPosition();
          this.setMobileIndex(this.mobileIndex);
          this.startMobileAutoplay();
          return;
        }
        this.stopMobileAutoplay();
        this.mobileLoopPositioned = false;
        this.mediaContainer.style.removeProperty('height');
        const rect = this.getBoundingClientRect();
        const distance = Math.max(1, this.offsetHeight - window.innerHeight);
        const progress = Math.min(1, Math.max(0, -rect.top / distance));
        const position = progress * Math.max(0, this.media.length - 1);
        const index = Math.min(this.labels.length - 1, Math.round(position));

        this.media.forEach((item, itemIndex) => {
          const itemProgress = itemIndex === 0
            ? 1
            : Math.min(1, Math.max(0, position - (itemIndex - 1)));
          const visual = this.visuals[itemIndex];
          const active = itemIndex === index;

          item.style.height = `${itemProgress * 100}%`;
          item.dataset.state = itemProgress <= 0 ? 'waiting' : itemProgress >= 1 ? 'done' : 'current';
          if (visual) {
            visual.style.transform = itemIndex === 0
              ? 'none'
              : `translate3d(0, ${(1 - itemProgress) * 50}px, 0)`;
          }
          item.setAttribute('aria-hidden', String(!active));
        });

        this.activeIndex = index;

        this.labels.forEach((label, itemIndex) => {
          const active = itemIndex === index;
          label.classList.toggle('is-active', active);
          if (active) {
            label.setAttribute('aria-current', 'true');
          } else {
            label.removeAttribute('aria-current');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-brand-introduction"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-brand-introduction-v10')) {
    customElements.define('about-brand-introduction-v10', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.about-brand-introduction__stage');
        this.firstCopy = this.querySelector('.about-brand-introduction__first-copy');
        this.frame = this.querySelector('.about-brand-introduction__frame');
        this.secondImage = this.querySelector('.about-brand-introduction__image--second');
        this.secondCopy = this.querySelector('.about-brand-introduction__second-copy');
        this.desktopGap = Number(this.dataset.gapDesktop) || 0;
        this.mobileGap = Number(this.dataset.gapMobile) || 0;
        this.finalMediaIsVideo = this.dataset.finalMediaVideo === 'true';
        this.videoBlur = Number(this.dataset.videoBlur) || 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.raf = 0;
        this.requestRender = this.requestRender.bind(this);
        this.initFirstReveal();
        window.addEventListener('scroll', this.requestRender, { passive: true });
        window.addEventListener('resize', this.requestRender);
        this.render();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.requestRender);
        window.removeEventListener('resize', this.requestRender);
        if (this.firstRevealObserver) this.firstRevealObserver.disconnect();
        cancelAnimationFrame(this.raf);
      }

      initFirstReveal() {
        if (!this.firstCopy || this.reducedMotion) return;
        this.firstRevealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const entersFromTop = entry.boundingClientRect.top < 0;
              this.style.setProperty('--abi-first-reveal-y', entersFromTop ? '-70px' : '70px');
              this.classList.toggle('is-first-entering-up', entersFromTop);
              this.classList.toggle('is-first-entering-down', !entersFromTop);
              this.classList.add('is-first-visible');
              return;
            }

            const exitsThroughTop = entry.boundingClientRect.bottom <= 0;
            this.style.setProperty('--abi-first-reveal-y', exitsThroughTop ? '-70px' : '70px');
            this.classList.remove('is-first-visible');
          });
        }, { threshold: .01 });
        this.firstRevealObserver.observe(this.firstCopy);
      }

      clamp(value) {
        return Math.min(1, Math.max(0, value));
      }

      mix(from, to, progress) {
        return from + ((to - from) * progress);
      }

      requestRender() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.render();
        });
      }

      render() {
        if (this.reducedMotion || !this.frame) return;
        const rect = this.getBoundingClientRect();
        const distance = Math.max(1, this.offsetHeight - window.innerHeight);
        const progress = this.clamp(-rect.top / distance);
        const unfold = this.clamp((progress - .12) / .38);
        const swap = this.clamp((progress - .48) / .22);
        const textIn = this.clamp((progress - .68) / .18);
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const startSide = mobile ? 20 : window.innerWidth * .09;
        const requestedTop = this.firstCopy.offsetTop + this.firstCopy.offsetHeight + (mobile ? this.mobileGap : this.desktopGap);
        const startTop = Math.min(window.innerHeight - 96, requestedTop);

        this.frame.style.setProperty('--abi-top', `${this.mix(startTop, 0, unfold)}px`);
        this.frame.style.setProperty('--abi-side', `${this.mix(startSide, 0, unfold)}px`);
        this.frame.style.setProperty('--abi-bottom', '0px');
        this.frame.style.setProperty('--abi-shade-progress', String(textIn));
        this.firstCopy.style.opacity = String(1 - this.clamp((progress - .08) / .16));
        this.firstCopy.style.transform = `translate(-50%, ${-24 * this.clamp(progress / .25)}px)`;
        this.secondImage.style.opacity = String(swap);
        this.secondImage.style.transform = `scale(${1.04 - (.04 * swap) + (this.finalMediaIsVideo ? .02 * textIn : 0)})`;
        this.secondImage.style.filter = this.finalMediaIsVideo ? `blur(${this.videoBlur * textIn}px)` : 'none';
        this.secondCopy.style.opacity = String(textIn);
        this.secondCopy.style.transform = `translate(-50%, ${(1 - textIn) * 34}px)`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-brand-vision"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-brand-vision-v10')) {
    customElements.define('about-brand-vision-v10', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.copy = this.querySelector('.about-brand-vision__copy');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.revealEnabled = this.dataset.revealEnabled === 'true';
        if (!this.copy || this.reducedMotion || !this.revealEnabled) {
          this.classList.add('is-visible');
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const entersFromTop = entry.boundingClientRect.top < 0;
              this.style.setProperty('--abv-reveal-y', entersFromTop ? '-70px' : '70px');
              this.classList.toggle('is-entering-up', entersFromTop);
              this.classList.toggle('is-entering-down', !entersFromTop);
              this.classList.add('is-visible');
              return;
            }

            const exitsThroughTop = entry.boundingClientRect.bottom <= 0;
            this.style.setProperty('--abv-reveal-y', exitsThroughTop ? '-70px' : '70px');
            this.classList.remove('is-visible');
          });
        }, { threshold: .01 });

        this.observer.observe(this.copy);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-centered-image-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-centered-image-content-v3')) {
    customElements.define('about-centered-image-content-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.copy = this.querySelector('.about-centered-image-content__copy');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.copy || this.reducedMotion) return;

        this.classList.add('is-reveal-ready');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const entersFromTop = entry.boundingClientRect.top < 0;
              this.style.setProperty('--aic-reveal-y', entersFromTop ? '-60px' : '60px');
              this.classList.toggle('is-entering-up', entersFromTop);
              this.classList.toggle('is-entering-down', !entersFromTop);
              this.classList.add('is-visible');
              return;
            }

            const exitsThroughTop = entry.boundingClientRect.bottom <= 0;
            this.style.setProperty('--aic-reveal-y', exitsThroughTop ? '-60px' : '60px');
            this.classList.remove('is-visible');
          });
        }, { threshold: .01 });

        this.observer.observe(this.copy);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-image-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-image-cta-v3')) {
    customElements.define('about-image-cta-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.copy = this.querySelector('.about-image-cta__copy');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.copy || this.reducedMotion) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const entersFromTop = entry.boundingClientRect.top < 0;
              this.style.setProperty('--aib-reveal-y', entersFromTop ? '-70px' : '70px');
              this.classList.toggle('is-entering-up', entersFromTop);
              this.classList.toggle('is-entering-down', !entersFromTop);
              this.classList.add('is-visible');
              return;
            }

            const exitsThroughTop = entry.boundingClientRect.bottom <= 0;
            this.style.setProperty('--aib-reveal-y', exitsThroughTop ? '-70px' : '70px');
            this.classList.remove('is-visible');
          });
        }, { threshold: .01 });

        this.observer.observe(this.copy);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-photo-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-photo-wall-v6')) {
    customElements.define('about-photo-wall-v6', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.about-photo-wall__grid');
        this.shade = this.querySelector('.about-photo-wall__stage-shade');
        this.heading = this.querySelector('[data-photo-wall-heading]');
        this.textOne = this.querySelector('[data-photo-wall-text-one]');
        this.textTwo = this.querySelector('[data-photo-wall-text-two]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.raf = 0;
        this.requestRender = this.requestRender.bind(this);
        window.addEventListener('scroll', this.requestRender, { passive: true });
        window.addEventListener('resize', this.requestRender);
        this.render();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.requestRender);
        window.removeEventListener('resize', this.requestRender);
        cancelAnimationFrame(this.raf);
      }

      clamp(value) {
        return Math.min(1, Math.max(0, value));
      }

      fadeBetween(progress, start, peak, end) {
        if (progress <= start || progress >= end) return 0;
        if (progress <= peak) return this.clamp((progress - start) / Math.max(.001, peak - start));
        return 1 - this.clamp((progress - peak) / Math.max(.001, end - peak));
      }

      setLayer(layer, opacity) {
        if (!layer) return;
        layer.style.opacity = String(opacity);
        layer.style.transform = `translate3d(0, ${(1 - opacity) * 36}px, 0)`;
      }

      requestRender() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.render();
        });
      }

      render() {
        if (!this.grid || this.reducedMotion || this.mobileQuery.matches) return;

        const rect = this.getBoundingClientRect();
        const distance = Math.max(1, this.offsetHeight - window.innerHeight);
        const progress = this.clamp(-rect.top / distance);
        const headingOpacity = this.fadeBetween(progress, .02, .12, .24);
        const textOneOpacity = this.fadeBetween(progress, .22, .33, .46);
        const textTwoOpacity = this.fadeBetween(progress, .44, .56, .70);
        const zoomProgress = this.clamp((progress - .68) / .32);
        const easedZoom = 1 - Math.pow(1 - zoomProgress, 3);
        const scale = 3 + ((1 - 3) * easedZoom);
        const copyOpacity = Math.max(headingOpacity, textOneOpacity, textTwoOpacity);

        this.grid.style.transform = `scale(${scale})`;
        this.setLayer(this.heading, headingOpacity);
        this.setLayer(this.textOne, textOneOpacity);
        this.setLayer(this.textTwo, textTwoOpacity);
        if (this.shade) this.shade.style.opacity = String(copyOpacity * parseFloat(getComputedStyle(this).getPropertyValue('--apw-overlay')));
        this.classList.toggle('is-ready', progress > .985);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-scroll-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-scroll-hero-v2')) {
    customElements.define('about-scroll-hero-v2', class extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-hero-step]'));
        this.media = this.querySelector('.about-scroll-hero__media');
        this.overlay = this.querySelector('.about-scroll-hero__overlay');
        this.overlayOpacity = Number(this.dataset.overlayOpacity) || 0;
        this.blurStrength = Number(this.dataset.blurStrength) || 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.raf = 0;
        this.requestRender = this.requestRender.bind(this);
        window.addEventListener('scroll', this.requestRender, { passive: true });
        window.addEventListener('resize', this.requestRender);
        this.render();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.requestRender);
        window.removeEventListener('resize', this.requestRender);
        cancelAnimationFrame(this.raf);
      }

      clamp(value) {
        return Math.min(1, Math.max(0, value));
      }

      smoothstep(start, end, value) {
        const progress = this.clamp((value - start) / Math.max(.001, end - start));
        return progress * progress * (3 - (2 * progress));
      }

      requestRender() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.render();
        });
      }

      render() {
        if (this.reducedMotion || !this.steps.length) return;
        const rect = this.getBoundingClientRect();
        const distance = Math.max(1, this.offsetHeight - window.innerHeight);
        const scrollDistance = Math.min(distance, Math.max(0, -rect.top));
        const hasStarted = scrollDistance > 1;
        this.classList.toggle('is-scrolled', hasStarted);

        if (!hasStarted) {
          if (this.media) {
            this.media.style.filter = 'none';
            this.media.style.transform = 'scale(1)';
          }
          if (this.overlay) this.overlay.style.opacity = '0';
          this.steps.forEach((step) => {
            step.classList.remove('is-visible');
            step.style.opacity = '0';
            step.style.transform = 'translateY(34px)';
          });
          return;
        }

        const stage = scrollDistance / Math.max(1, window.innerHeight);
        const reveal = this.clamp(stage);

        if (this.media) {
          this.media.style.filter = `blur(${reveal * this.blurStrength}px)`;
          this.media.style.transform = `scale(${1 + (reveal * .035)})`;
        }
        if (this.overlay) this.overlay.style.opacity = String(reveal * this.overlayOpacity);

        this.steps.forEach((step, index) => {
          const localProgress = stage - index;
          const fadeIn = this.smoothstep(.08, .30, localProgress);
          const fadeOut = index === this.steps.length - 1
            ? 1
            : 1 - this.smoothstep(.70, .90, localProgress);
          const opacity = this.clamp(fadeIn * fadeOut);
          step.classList.toggle('is-visible', opacity > .001);
          step.style.opacity = String(opacity);
          step.style.transform = `translateY(${(1 - opacity) * 34}px)`;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-technology-platform"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-technology-platform-v1')) {
    customElements.define('about-technology-platform-v1', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.copy = this.querySelector('[data-platform-reveal]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.copy || this.reducedMotion) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const entersFromTop = entry.boundingClientRect.top < 0;
              this.style.setProperty('--atp-reveal-y', entersFromTop ? '-70px' : '70px');
              this.classList.toggle('is-entering-up', entersFromTop);
              this.classList.toggle('is-entering-down', !entersFromTop);
              this.classList.add('is-visible');
              return;
            }

            const exitsThroughTop = entry.boundingClientRect.bottom <= 0;
            this.style.setProperty('--atp-reveal-y', exitsThroughTop ? '-70px' : '70px');
            this.classList.remove('is-visible');
          });
        }, { threshold: .01 });

        this.observer.observe(this.copy);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ax9-ultra-platform"] && !Shopify.designMode) return;
  try {
    
  function ax9PlatformActivate(root, id) {
    var tabs = Array.from(root.querySelectorAll('[data-ax9-platform-tab]'));
    var activeIndex = tabs.findIndex(function (tab) { return tab.dataset.ax9PlatformTab === id; });
    if (activeIndex < 0) return;
    root.dataset.activeIndex = String(activeIndex);
    root.querySelector('.ax9-platform__tabs').dataset.activeIndex = String(activeIndex);
    tabs.forEach(function (tab) {
      var active = tab.dataset.ax9PlatformTab === id;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-ax9-platform-panel]').forEach(function (panel) {
      var active = panel.dataset.ax9PlatformPanel === id;
      panel.hidden = !active;
      panel.inert = !active;
      panel.classList.toggle('is-active', active);
    });
  }
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-ax9-platform-tab]');
    if (tab) ax9PlatformActivate(tab.closest('[data-ax9-platform]'), tab.dataset.ax9PlatformTab);
  });
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-ax9-platform-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    var tabs = Array.from(tab.closest('[data-ax9-platform]').querySelectorAll('[data-ax9-platform-tab]'));
    var current = tabs.indexOf(tab);
    var next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    tabs[next].focus();
    ax9PlatformActivate(tab.closest('[data-ax9-platform]'), tabs[next].dataset.ax9PlatformTab);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest('[data-ax9-platform-tab]');
    if (tab) ax9PlatformActivate(tab.closest('[data-ax9-platform]'), tab.dataset.ax9PlatformTab);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ax9-ultra-power"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ax9-video-open]');
    if (opener) {
      var dialog = document.getElementById(opener.dataset.ax9VideoOpen);
      if (dialog && !dialog.open) {
        var youtube = dialog.querySelector('[data-ax9-video-src]');
        if (youtube) youtube.src = youtube.dataset.ax9VideoSrc;
        dialog.showModal();
        var video = dialog.querySelector('video');
        if (video) {
          var playResult = video.play();
          if (playResult && playResult.catch) playResult.catch(function () {});
        }
      }
      return;
    }
    var closer = event.target.closest('[data-ax9-video-close]');
    if (closer) closer.closest('dialog').close();
  });
  document.addEventListener('close', function (event) {
    if (!event.target.classList.contains('ax9-power__video-dialog')) return;
    var video = event.target.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    var youtube = event.target.querySelector('[data-ax9-video-src]');
    if (youtube) youtube.removeAttribute('src');
  }, true);
  function ax9PowerActivate(root, id) {
    root.querySelectorAll('[data-ax9-switch]').forEach(function (button) {
      var active = button.dataset.ax9Switch === id;
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
      button.closest('.ax9-power__switch').classList.toggle('is-active', active);
      var description = button.closest('.ax9-power__switch').querySelector('.ax9-power__switch-description');
      if (description) {
        description.setAttribute('aria-hidden', active ? 'false' : 'true');
        description.inert = !active;
      }
      button.querySelector('.ax9-power__switch-glyph').textContent = active ? '−' : '+';
    });
    root.querySelectorAll('[data-ax9-panel]').forEach(function (panel) {
      var active = panel.dataset.ax9Panel === id;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      panel.inert = !active;
      if (active) root.querySelector('.ax9-power__panels').style.setProperty('--power-active-aspect-mobile', panel.dataset.ax9AspectMobile);
    });
  }
  function ax9PowerStopAuto(root) {
    if (!root || !root.ax9PowerAutoTimer) return;
    clearInterval(root.ax9PowerAutoTimer);
    root.ax9PowerAutoTimer = null;
  }
  function ax9PowerStartAuto(root) {
    if (root.ax9PowerAutoTimer || root.dataset.ax9AutoStopped === 'true') return;
    if (root.querySelectorAll('[data-ax9-switch]').length < 2) return;
    root.ax9PowerAutoTimer = setInterval(function () {
      if (!root.isConnected) {
        ax9PowerStopAuto(root);
        return;
      }
      var buttons = Array.from(root.querySelectorAll('[data-ax9-switch]'));
      if (buttons.length < 2) {
        ax9PowerStopAuto(root);
        return;
      }
      var current = buttons.findIndex(function (button) { return button.getAttribute('aria-selected') === 'true'; });
      ax9PowerActivate(root, buttons[(current + 1) % buttons.length].dataset.ax9Switch);
    }, 3000);
  }
  function ax9PowerStopAfterInteraction(root) {
    root.dataset.ax9AutoStopped = 'true';
    ax9PowerStopAuto(root);
  }
  function ax9PowerInitAuto(container) {
    container.querySelectorAll('[data-ax9-switch-root]').forEach(ax9PowerStartAuto);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ax9PowerInitAuto(document); });
  } else {
    ax9PowerInitAuto(document);
  }
  document.addEventListener('shopify:section:load', function (event) { ax9PowerInitAuto(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-ax9-switch-root]').forEach(ax9PowerStopAuto);
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ax9-switch]');
    if (!button) return;
    var root = button.closest('[data-ax9-switch-root]');
    ax9PowerStopAfterInteraction(root);
    ax9PowerActivate(root, button.dataset.ax9Switch);
  });
  document.addEventListener('keydown', function (event) {
    var button = event.target.closest('[data-ax9-switch]');
    if (!button || !['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
    var buttons = Array.from(button.closest('[data-ax9-switch-root]').querySelectorAll('[data-ax9-switch]'));
    var current = buttons.indexOf(button);
    var next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    event.preventDefault();
    buttons[next].focus();
    var root = button.closest('[data-ax9-switch-root]');
    ax9PowerStopAfterInteraction(root);
    ax9PowerActivate(root, buttons[next].dataset.ax9Switch);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target.closest('.ax9-power__switch');
    if (block) {
      var button = block.querySelector('[data-ax9-switch]');
      var root = button.closest('[data-ax9-switch-root]');
      ax9PowerStopAfterInteraction(root);
      ax9PowerActivate(root, button.dataset.ax9Switch);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-intercom"] && !Shopify.designMode) return;
  try {
    

(() => {

  const MAX_FILES = 5;

  const MAX_IMAGE_SIZE =
    10 * 1024 * 1024;

  const MAX_VIDEO_SIZE =
    100 * 1024 * 1024;

  /*
   * Turnstile 最多等待 6 秒。
   * 未完成自动走 fallback。
   */
  const FALLBACK_DELAY =
    6000;

  const IMAGE_EXTENSIONS = [
    'jpg',
    'jpeg',
    'png',
    'webp',
    'gif'
  ];

  const VIDEO_EXTENSIONS = [
    'mp4',
    'webm',
    'mov'
  ];

  const UPLOAD_ENDPOINT =
    'https://fin.geekom.ca/api/upload.php';

  const TICKET_ENDPOINT =
    'https://fin.geekom.ca/api/intercom-ticket.php';

  const VERIFY_HUMAN_ENDPOINT =
    'https://fin.geekom.ca/api/verify-human.php';

  const TURNSTILE_API =
    'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

  let turnstileLoader =
    null;


  const getExtension =
    (
      fileName
    ) => {

      const parts =
        fileName
          .toLowerCase()
          .split('.');

      return parts.length > 1
        ? parts.pop()
        : '';
    };


  const replaceTokens =
    (
      text,
      values = {}
    ) => {

      let output =
        String(
          text ||
          ''
        );

      Object
        .entries(values)
        .forEach(
          (
            [
              key,
              value
            ]
          ) => {

            output =
              output
                .split(
                  `[${key}]`
                )
                .join(
                  String(value)
                );
          }
        );

      return output;
    };


  const formatBytes =
    (
      bytes,
      copy
    ) => {

      if (
        bytes <
        1024
      ) {
        return (
          `${bytes} ` +
          `${copy.bytes_unit || 'B'}`
        );
      }

      if (
        bytes <
        1024 * 1024
      ) {
        return (
          `${(
            bytes / 1024
          ).toFixed(1)} ` +
          `${copy.kb_unit || 'KB'}`
        );
      }

      return (
        `${(
          bytes /
          (
            1024 *
            1024
          )
        ).toFixed(1)} ` +
        `${copy.mb_unit || 'MB'}`
      );
    };


  const loadTurnstile =
    () => {

      if (
        window.turnstile
      ) {
        return Promise.resolve(
          window.turnstile
        );
      }

      if (
        turnstileLoader
      ) {
        return turnstileLoader;
      }

      turnstileLoader =
        new Promise(
          (
            resolve,
            reject
          ) => {

            const existing =
              document
                .querySelector(
                  'script[data-vzmore-turnstile-api]'
                );

            if (
              existing
            ) {

              if (
                window.turnstile
              ) {

                resolve(
                  window.turnstile
                );

                return;
              }

              existing
                .addEventListener(
                  'load',
                  () => {

                    if (
                      window.turnstile
                    ) {

                      resolve(
                        window.turnstile
                      );

                    } else {

                      reject(
                        new Error(
                          'Turnstile unavailable'
                        )
                      );
                    }
                  },
                  {
                    once:
                      true
                  }
                );

              existing
                .addEventListener(
                  'error',
                  () => {

                    reject(
                      new Error(
                        'Turnstile failed to load'
                      )
                    );
                  },
                  {
                    once:
                      true
                  }
                );

              return;
            }

            const script =
              document
                .createElement(
                  'script'
                );

            script.src =
              TURNSTILE_API;

            script.async =
              true;

            script.defer =
              true;

            script.dataset
              .vzmoreTurnstileApi =
              'true';

            script
              .addEventListener(
                'load',
                () => {

                  if (
                    window.turnstile
                  ) {

                    resolve(
                      window.turnstile
                    );

                  } else {

                    reject(
                      new Error(
                        'Turnstile unavailable'
                      )
                    );
                  }
                },
                {
                  once:
                    true
                }
              );

            script
              .addEventListener(
                'error',
                () => {

                  reject(
                    new Error(
                      'Turnstile failed to load'
                    )
                  );
                },
                {
                  once:
                    true
                }
              );

            document
              .head
              .appendChild(
                script
              );
          }
        );

      return turnstileLoader;
    };


  const initForms =
    () => {

      document
        .querySelectorAll(
          '[data-intercom-contact-form]'
        )
        .forEach(
          (
            form
          ) => {

            if (
              form.dataset
                .initialized ===
              'true'
            ) {
              return;
            }

            form.dataset
              .initialized =
              'true';

            const section =
              form.closest(
                '.intercom-contact'
              );

            const copyElement =
              section
                ?.querySelector(
                  '[data-intercom-contact-copy]'
                );

            const button =
              form.querySelector(
                '[data-submit-button]'
              );

            const submitLabel =
              form.querySelector(
                '[data-submit-label]'
              );

            const status =
              form.querySelector(
                '[data-form-status]'
              );

            const statusIcon =
              form.querySelector(
                '[data-status-icon]'
              );

            const statusTitle =
              form.querySelector(
                '[data-status-title]'
              );

            const statusMessage =
              form.querySelector(
                '[data-status-message]'
              );

            const fileInput =
              form.querySelector(
                '[data-attachment-input]'
              );

            const fileList =
              form.querySelector(
                '[data-file-list]'
              );

            const fileError =
              form.querySelector(
                '[data-file-error]'
              );

            const turnstileContainer =
              form.querySelector(
                '[data-turnstile-widget]'
              );

            const humanBox =
              form.querySelector(
                '[data-human-box]'
              );

            const humanStatus =
              form.querySelector(
                '[data-human-status]'
              );

            const humanLoading =
              form.querySelector(
                '[data-human-loading]'
              );

            if (
              !section ||
              !button ||
              !submitLabel ||
              !status ||
              !statusIcon ||
              !statusTitle ||
              !statusMessage ||
              !fileInput ||
              !fileList ||
              !fileError ||
              !turnstileContainer ||
              !humanBox ||
              !humanStatus ||
              !humanLoading
            ) {
              return;
            }

            let copy =
              {};

            try {

              copy =
                JSON.parse(
                  copyElement
                    ?.textContent ||
                  '{}'
                );

            } catch (
              error
            ) {

              console.error(
                'Contact form copy config error:',
                error
              );
            }

            let selectedFiles =
              [];

            let humanToken =
              '';

            let humanTokenExpiresAt =
              0;

            let turnstileWidgetId =
              null;

            let submittedState =
              false;

            let fallbackTimer =
              null;

            let fallbackPromise =
              null;


            const setFileError =
              (
                message = ''
              ) => {

                fileError.textContent =
                  message;

                fileError.hidden =
                  message === '';
              };


            const hideNotice =
              () => {

                status.hidden =
                  true;

                status
                  .removeAttribute(
                    'data-state'
                  );

                statusIcon.textContent =
                  '';

                statusTitle.textContent =
                  '';

                statusMessage.textContent =
                  '';
              };


            const showNotice =
              (
                state,
                title,
                message
              ) => {

                status.hidden =
                  false;

                status.dataset.state =
                  state;

                statusIcon.textContent =
                  state ===
                    'success'
                    ? '✓'
                    : (
                      state ===
                        'warning'
                        ? '!'
                        : '×'
                    );

                statusTitle.textContent =
                  title ||
                  '';

                statusMessage.textContent =
                  message ||
                  '';
              };


            const setHumanStatus =
              (
                message = '',
                state = ''
              ) => {

                humanStatus.textContent =
                  message;

                humanBox
                  .classList
                  .toggle(
                    'is-verified',
                    state ===
                      'success'
                  );

                humanBox
                  .classList
                  .toggle(
                    'is-error',
                    state ===
                      'error'
                  );

                humanLoading.hidden =
                  state !==
                  'loading';
              };


            const clearFallbackTimer =
              () => {

                if (
                  fallbackTimer !==
                  null
                ) {

                  window
                    .clearTimeout(
                      fallbackTimer
                    );

                  fallbackTimer =
                    null;
                }
              };


            const clearHumanToken =
              () => {

                humanToken =
                  '';

                humanTokenExpiresAt =
                  0;
              };


            const hasValidHumanToken =
              () => {

                return (
                  humanToken !==
                    '' &&

                  humanTokenExpiresAt >
                    (
                      Date.now() +
                      10000
                    )
                );
              };


            const saveHumanToken =
              (
                data
              ) => {

                if (
                  !data?.success ||
                  typeof data
                    .human_token !==
                    'string' ||
                  data.human_token ===
                    ''
                ) {

                  throw new Error(
                    copy
                      .human_failed ||
                    'Human verification failed.'
                  );
                }

                humanToken =
                  data.human_token;

                const expiresIn =
                  Number(
                    data
                      .expires_in ||
                    1800
                  );

                humanTokenExpiresAt =
                  Date.now() +
                  (
                    expiresIn *
                    1000
                  );

                clearFallbackTimer();

                setHumanStatus(
                  copy
                    .human_verified ||
                  'Verification successful.',
                  'success'
                );

                return humanToken;
              };


            const requestHumanToken =
              async (
                payload
              ) => {

                const response =
                  await fetch(
                    VERIFY_HUMAN_ENDPOINT,
                    {
                      method:
                        'POST',

                      headers: {
                        'Content-Type':
                          'application/json'
                      },

                      body:
                        JSON.stringify(
                          payload
                        )
                    }
                  );

                const data =
                  await response
                    .json()
                    .catch(
                      () =>
                        null
                    );

                if (
                  !response.ok ||
                  !data?.success
                ) {

                  throw new Error(
                    data?.message ||
                    copy
                      .human_failed ||
                    'Human verification failed.'
                  );
                }

                return data;
              };


            const requestFallbackHumanToken =
              async () => {

                if (
                  hasValidHumanToken()
                ) {

                  clearFallbackTimer();

                  return humanToken;
                }

                if (
                  fallbackPromise
                ) {
                  return fallbackPromise;
                }

                fallbackPromise =
                  (
                    async () => {

                      try {

                        const data =
                          await requestHumanToken({
                            fallback:
                              true
                          });

                        return saveHumanToken(
                          data
                        );

                      } finally {

                        fallbackPromise =
                          null;
                      }

                    }
                  )();

                return fallbackPromise;
              };


            const scheduleFallback =
              () => {

                clearFallbackTimer();

                fallbackTimer =
                  window
                    .setTimeout(
                      () => {

                        if (
                          hasValidHumanToken()
                        ) {
                          return;
                        }

                        requestFallbackHumanToken()
                          .catch(
                            (
                              error
                            ) => {

                              console.error(
                                'Automatic verification fallback failed:',
                                error
                              );

                              setHumanStatus(
                                copy
                                  .generic_error ||
                                'We could not verify this request. Please try again.',
                                'error'
                              );
                            }
                          );

                      },
                      FALLBACK_DELAY
                    );
              };


            const ensureHumanToken =
              async () => {

                if (
                  hasValidHumanToken()
                ) {
                  return humanToken;
                }

                return requestFallbackHumanToken();
              };


            const verifyHuman =
              async (
                turnstileToken
              ) => {

                if (
                  hasValidHumanToken()
                ) {
                  return humanToken;
                }

                setHumanStatus(
                  copy
                    .human_verifying ||
                  'Verifying...',
                  ''
                );

                try {

                  const data =
                    await requestHumanToken({
                      turnstile_token:
                        turnstileToken
                    });

                  if (
                    hasValidHumanToken()
                  ) {
                    return humanToken;
                  }

                  return saveHumanToken(
                    data
                  );

                } catch (
                  error
                ) {

                  if (
                    hasValidHumanToken()
                  ) {
                    return humanToken;
                  }

                  throw error;
                }
              };


            const resetTurnstile =
              () => {

                if (
                  window.turnstile &&
                  turnstileWidgetId !==
                    null
                ) {

                  try {

                    window
                      .turnstile
                      .reset(
                        turnstileWidgetId
                      );

                  } catch (
                    error
                  ) {

                    console.warn(
                      'Turnstile reset warning:',
                      error
                    );
                  }
                }
              };


            const initTurnstile =
              async () => {

                const siteKey =
                  (
                    turnstileContainer
                      .dataset
                      .siteKey ||
                    ''
                  ).trim();

                setHumanStatus(
                  '',
                  'loading'
                );

                scheduleFallback();

                if (
                  !siteKey
                ) {

                  requestFallbackHumanToken()
                    .catch(
                      (
                        error
                      ) => {

                        console.error(
                          'Automatic fallback failed:',
                          error
                        );
                      }
                    );

                  return;
                }

                try {

                  const turnstile =
                    await loadTurnstile();

                  if (
                    hasValidHumanToken()
                  ) {
                    return;
                  }

                  if (
                    turnstileWidgetId !==
                    null
                  ) {

                    try {

                      turnstile
                        .remove(
                          turnstileWidgetId
                        );

                    } catch (
                      error
                    ) {

                      console.warn(
                        'Turnstile remove warning:',
                        error
                      );
                    }

                    turnstileWidgetId =
                      null;
                  }

                  turnstileContainer
                    .replaceChildren();

                  turnstileWidgetId =
                    turnstile
                      .render(
                        turnstileContainer,
                        {
                          sitekey:
                            siteKey,

                          action:
                            'contact_form',

                          theme:
                            'auto',

                          size:
                            'flexible',

                          appearance:
                            'always',

                          retry:
                            'auto',

                          'retry-interval':
                            5000,

                          'refresh-expired':
                            'auto',

                          'refresh-timeout':
                            'auto',

                          language:
                            'auto',

                          'response-field':
                            false,

                          callback:
                            async (
                              token
                            ) => {

                              if (
                                hasValidHumanToken()
                              ) {
                                return;
                              }

                              try {

                                await verifyHuman(
                                  token
                                );

                              } catch (
                                error
                              ) {

                                console.warn(
                                  'Turnstile verification failed, using automatic fallback:',
                                  error
                                );

                                if (
                                  !hasValidHumanToken()
                                ) {

                                  requestFallbackHumanToken()
                                    .catch(
                                      (
                                        fallbackError
                                      ) => {

                                        console.error(
                                          'Automatic fallback failed:',
                                          fallbackError
                                        );
                                      }
                                    );
                                }
                              }
                            },

                          'expired-callback':
                            () => {

                              if (
                                !hasValidHumanToken()
                              ) {

                                requestFallbackHumanToken()
                                  .catch(
                                    (
                                      error
                                    ) => {

                                      console.error(
                                        'Turnstile expired fallback failed:',
                                        error
                                      );
                                    }
                                  );
                              }
                            },

                          'timeout-callback':
                            () => {

                              if (
                                !hasValidHumanToken()
                              ) {

                                requestFallbackHumanToken()
                                  .catch(
                                    (
                                      error
                                    ) => {

                                      console.error(
                                        'Turnstile timeout fallback failed:',
                                        error
                                      );
                                    }
                                  );
                              }
                            },

                          'error-callback':
                            (
                              errorCode
                            ) => {

                              console.warn(
                                'Turnstile unavailable, using automatic fallback:',
                                errorCode
                              );

                              if (
                                !hasValidHumanToken()
                              ) {

                                requestFallbackHumanToken()
                                  .catch(
                                    (
                                      error
                                    ) => {

                                      console.error(
                                        'Automatic fallback failed:',
                                        error
                                      );
                                    }
                                  );
                              }

                              return true;
                            }
                        }
                      );

                } catch (
                  error
                ) {

                  console.warn(
                    'Turnstile load error, using fallback:',
                    error
                  );

                  if (
                    !hasValidHumanToken()
                  ) {

                    requestFallbackHumanToken()
                      .catch(
                        (
                          fallbackError
                        ) => {

                          console.error(
                            'Automatic fallback failed:',
                            fallbackError
                          );

                          setHumanStatus(
                            copy
                              .generic_error ||
                            'We could not verify this request. Please try again.',
                            'error'
                          );
                        }
                      );
                  }
                }
              };


            const startNewSubmission =
              () => {

                if (
                  !submittedState
                ) {
                  return;
                }

                submittedState =
                  false;

                form
                  .classList
                  .remove(
                    'is-submitted'
                  );

                hideNotice();

                clearHumanToken();

                setHumanStatus(
                  '',
                  ''
                );

                resetTurnstile();

                initTurnstile();
              };


            form
              .addEventListener(
                'input',
                startNewSubmission
              );

            form
              .addEventListener(
                'change',
                startNewSubmission
              );


            const validateFile =
              (
                file
              ) => {

                const extension =
                  getExtension(
                    file.name
                  );

                if (
                  IMAGE_EXTENSIONS
                    .includes(
                      extension
                    )
                ) {

                  if (
                    file.size >
                    MAX_IMAGE_SIZE
                  ) {

                    return replaceTokens(
                      copy
                        .image_too_large,
                      {
                        file:
                          file.name,

                        size:
                          10
                      }
                    );
                  }

                  return '';
                }

                if (
                  VIDEO_EXTENSIONS
                    .includes(
                      extension
                    )
                ) {

                  if (
                    file.size >
                    MAX_VIDEO_SIZE
                  ) {

                    return replaceTokens(
                      copy
                        .video_too_large,
                      {
                        file:
                          file.name,

                        size:
                          100
                      }
                    );
                  }

                  return '';
                }

                return replaceTokens(
                  copy
                    .unsupported_file,
                  {
                    file:
                      file.name
                  }
                );
              };


            const renderFiles =
              () => {

                fileList.innerHTML =
                  '';

                selectedFiles
                  .forEach(
                    (
                      file,
                      index
                    ) => {

                      const extension =
                        getExtension(
                          file.name
                        );

                      const isVideo =
                        VIDEO_EXTENSIONS
                          .includes(
                            extension
                          );

                      const item =
                        document
                          .createElement(
                            'div'
                          );

                      const type =
                        document
                          .createElement(
                            'span'
                          );

                      const info =
                        document
                          .createElement(
                            'div'
                          );

                      const name =
                        document
                          .createElement(
                            'span'
                          );

                      const size =
                        document
                          .createElement(
                            'span'
                          );

                      const remove =
                        document
                          .createElement(
                            'button'
                          );

                      item.className =
                        'intercom-contact__file-item';

                      type.className =
                        'intercom-contact__file-type';

                      info.className =
                        'intercom-contact__file-info';

                      name.className =
                        'intercom-contact__file-name';

                      size.className =
                        'intercom-contact__file-size';

                      remove.className =
                        'intercom-contact__file-remove';

                      type.textContent =
                        isVideo
                          ? copy
                              .video_badge
                          : copy
                              .image_badge;

                      name.textContent =
                        file.name;

                      size.textContent =
                        formatBytes(
                          file.size,
                          copy
                        );

                      remove.type =
                        'button';

                      remove.textContent =
                        copy
                          .remove_symbol ||
                        '×';

                      remove
                        .setAttribute(
                          'aria-label',
                          replaceTokens(
                            copy
                              .remove_file,
                            {
                              file:
                                file.name
                            }
                          )
                        );

                      remove
                        .addEventListener(
                          'click',
                          () => {

                            selectedFiles
                              .splice(
                                index,
                                1
                              );

                            setFileError(
                              ''
                            );

                            renderFiles();
                          }
                        );

                      info.append(
                        name,
                        size
                      );

                      item.append(
                        type,
                        info,
                        remove
                      );

                      fileList
                        .appendChild(
                          item
                        );
                    }
                  );
              };


            fileInput
              .addEventListener(
                'change',
                () => {

                  setFileError(
                    ''
                  );

                  const incomingFiles =
                    Array.from(
                      fileInput.files ||
                      []
                    );

                  const nextFiles = [
                    ...selectedFiles
                  ];

                  for (
                    const file
                    of incomingFiles
                  ) {

                    const error =
                      validateFile(
                        file
                      );

                    if (
                      error
                    ) {

                      setFileError(
                        error
                      );

                      fileInput.value =
                        '';

                      return;
                    }

                    const duplicate =
                      nextFiles
                        .some(
                          (
                            currentFile
                          ) => (

                            currentFile.name ===
                              file.name &&

                            currentFile.size ===
                              file.size &&

                            currentFile.lastModified ===
                              file.lastModified
                          )
                        );

                    if (
                      !duplicate
                    ) {

                      nextFiles
                        .push(
                          file
                        );
                    }
                  }

                  if (
                    nextFiles.length >
                    MAX_FILES
                  ) {

                    setFileError(
                      replaceTokens(
                        copy
                          .max_files,
                        {
                          max_files:
                            MAX_FILES
                        }
                      )
                    );

                    fileInput.value =
                      '';

                    return;
                  }

                  selectedFiles =
                    nextFiles;

                  fileInput.value =
                    '';

                  renderFiles();
                }
              );


            const uploadAttachments =
              async () => {

                if (
                  selectedFiles.length ===
                  0
                ) {
                  return [];
                }

                await ensureHumanToken();

                const uploadData =
                  new FormData();

                selectedFiles
                  .forEach(
                    (
                      file
                    ) => {

                      uploadData
                        .append(
                          'attachments[]',
                          file,
                          file.name
                        );
                    }
                  );

                const sendUpload =
                  () =>
                    fetch(
                      UPLOAD_ENDPOINT,
                      {
                        method:
                          'POST',

                        headers: {
                          'X-Human-Token':
                            humanToken
                        },

                        body:
                          uploadData
                      }
                    );

                let response =
                  await sendUpload();

                if (
                  response.status ===
                  403
                ) {

                  clearHumanToken();

                  await ensureHumanToken();

                  response =
                    await sendUpload();
                }

                const data =
                  await response
                    .json()
                    .catch(
                      () =>
                        null
                    );

                if (
                  !response.ok ||
                  !data?.success ||
                  !Array.isArray(
                    data.files
                  )
                ) {

                  console.error(
                    'Upload API error:',
                    data
                  );

                  throw new Error(
                    copy
                      .upload_failed ||
                    copy
                      .generic_error
                  );
                }

                const urls =
                  data.files
                    .map(
                      (
                        file
                      ) =>
                        file?.url
                    )
                    .filter(
                      (
                        url
                      ) =>

                        typeof url ===
                          'string' &&

                        url !==
                          ''
                    );

                if (
                  urls.length !==
                  selectedFiles.length
                ) {

                  throw new Error(
                    copy
                      .partial_upload_failed ||

                    copy
                      .upload_failed ||

                    copy
                      .generic_error
                  );
                }

                return urls;
              };


            form
              .addEventListener(
                'submit',
                async (
                  event
                ) => {

                  event
                    .preventDefault();

                  setFileError(
                    ''
                  );

                  hideNotice();

                  /*
                   * HTML required validation.
                   * Required/Optional is generated from Theme Editor settings.
                   */
                  if (
                    !form
                      .checkValidity()
                  ) {

                    form
                      .reportValidity();

                    return;
                  }

                  /*
                   * Attachments are managed separately from FormData,
                   * so required attachment validation is done here.
                   */
                  if (
                    copy
                      .attachments_required ===
                      true &&

                    selectedFiles.length ===
                      0
                  ) {

                    setFileError(
                      copy
                        .attachments_required_error ||
                      'Please upload at least one attachment.'
                    );

                    fileInput
                      .focus();

                    return;
                  }

                  if (
                    selectedFiles.length >
                    MAX_FILES
                  ) {

                    setFileError(
                      replaceTokens(
                        copy
                          .max_files,
                        {
                          max_files:
                            MAX_FILES
                        }
                      )
                    );

                    return;
                  }

                  for (
                    const file
                    of selectedFiles
                  ) {

                    const error =
                      validateFile(
                        file
                      );

                    if (
                      error
                    ) {

                      setFileError(
                        error
                      );

                      return;
                    }
                  }

                  button.disabled =
                    true;

                  fileInput.disabled =
                    true;

                  try {

                    await ensureHumanToken();

                    let attachmentUrls =
                      [];

                    if (
                      selectedFiles.length >
                      0
                    ) {

                      submitLabel
                        .textContent =
                        copy
                          .uploading ||
                        copy
                          .submit;

                      attachmentUrls =
                        await uploadAttachments();
                    }

                    await ensureHumanToken();

                    submitLabel
                      .textContent =
                      copy
                        .submitting ||
                      copy
                        .submit;

                    const formData =
                      new FormData(
                        form
                      );

                    const payload =
                      Object
                        .fromEntries(
                          formData
                            .entries()
                        );

                    payload
                      .attachment_urls =
                      attachmentUrls;

                    const sendTicket =
                      () =>
                        fetch(
                          TICKET_ENDPOINT,
                          {
                            method:
                              'POST',

                            headers: {
                              'Content-Type':
                                'application/json',

                              'X-Human-Token':
                                humanToken
                            },

                            body:
                              JSON.stringify(
                                payload
                              )
                          }
                        );

                    let response =
                      await sendTicket();

                    if (
                      response.status ===
                      403
                    ) {

                      clearHumanToken();

                      await ensureHumanToken();

                      response =
                        await sendTicket();
                    }

                    const data =
                      await response
                        .json()
                        .catch(
                          () =>
                            null
                        );

                    if (
                      !response.ok ||
                      !data?.success
                    ) {

                      console.error(
                        'Ticket API error:',
                        data
                      );

                      throw new Error(
                        copy
                          .submission_failed ||
                        copy
                          .generic_error
                      );
                    }

                    const displayTicketId =
                      data.ticket
                        ?.ticket_id ||
                      '';

                    form.reset();

                    selectedFiles =
                      [];

                    renderFiles();

                    clearFallbackTimer();

                    clearHumanToken();

                    resetTurnstile();

                    setHumanStatus(
                      '',
                      ''
                    );

                    submittedState =
                      true;

                    form
                      .classList
                      .add(
                        'is-submitted'
                      );

                    if (
                      data.warning
                    ) {

                      const message =
                        displayTicketId
                          ? replaceTokens(
                            copy
                              .warning_ticket,
                            {
                              ticket_id:
                                displayTicketId
                            }
                          )
                          : copy
                              .warning;

                      showNotice(
                        'warning',

                        copy
                          .warning_title ||
                        'Request submitted with a warning',

                        message
                      );

                    } else {

                      const message =
                        displayTicketId
                          ? replaceTokens(
                            copy
                              .success_ticket,
                            {
                              ticket_id:
                                displayTicketId
                            }
                          )
                          : copy
                              .success;

                      showNotice(
                        'success',

                        copy
                          .success_title ||
                        'Request submitted',

                        message
                      );
                    }

                    status
                      .scrollIntoView({
                        behavior:
                          'smooth',

                        block:
                          'nearest'
                      });

                  } catch (
                    error
                  ) {

                    showNotice(
                      'error',
                      '',

                      error
                        instanceof
                          Error &&
                      error.message
                        ? error.message
                        : copy
                            .generic_error
                    );

                    console.error(
                      'Intercom contact form error:',
                      error
                    );

                  } finally {

                    button.disabled =
                      false;

                    fileInput.disabled =
                      false;

                    submitLabel
                      .textContent =
                      copy
                        .submit ||
                      'Submit';
                  }
                }
              );

            initTurnstile();
          }
        );
    };


  if (
    document.readyState ===
      'loading'
  ) {

    document
      .addEventListener(
        'DOMContentLoaded',
        initForms,
        {
          once:
            true
        }
      );

  } else {

    initForms();
  }

  document
    .addEventListener(
      'shopify:section:load',
      initForms
    );

})();


  } catch(e) { console.error(e); }
})();
})();
